import localePt from "@angular/common/locales/pt";
import { AppComponent } from "./app/app.component";
import { bootstrapApplication } from "@angular/platform-browser";
import {
  enableProdMode,
  importProvidersFrom,
  InjectionToken,
  LOCALE_ID,
  provideZoneChangeDetection
} from "@angular/core";
import { environment } from "./environments/environment";
import { silenciarConsoleDeDebug } from "./app/core/console";
import { File } from "@awesome-cordova-plugins/file/ngx";
import { FileOpener } from "@awesome-cordova-plugins/file-opener/ngx";
import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import {} from '@angular/common/http';
import { NativePageTransitions } from "@awesome-cordova-plugins/native-page-transitions/ngx";
import { PreviewAnyFile } from "@awesome-cordova-plugins/preview-any-file/ngx";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideIonicAngular } from "@ionic/angular/standalone";
import { provideRouter, RouteReuseStrategy } from "@angular/router";
import { register } from "swiper/element/bundle";
import { registerLocaleData } from "@angular/common";
import { routes, visualProviders } from "./app/app.routes";
import { Storage } from "@ionic/storage";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { JwtInterceptor } from "./app/visual-app/shared/interceptors/token.interceptor";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { HttpClient } from "@angular/common/http";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

registerLocaleData(localePt);

register();

if (environment.production) {
  enableProdMode();
  silenciarConsoleDeDebug();
}

// Constantes de API agora vivem em src/app/core/api-config.ts —
// exportá-las daqui criava import circular (specs → serviços → main.ts → bootstrap).

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: LOCALE_ID, useValue: "pt-BR" },
    provideIonicAngular(),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    importProvidersFrom(IonicModule.forRoot({ mode: "md" })),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: "pt",
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
        },
      })
    ),
    provideRouter(routes),
    NativePageTransitions,
    FileOpener,
    File,
    Storage,
    PreviewAnyFile,
    provideAnimations(),
    ...visualProviders,
  ],
});
